export function useDirtyTracking() {

  // Map pour stocker les hash initiaux
  const initialHashes = new Map()

  /**
   * Créer un hash simple et rapide d'un objet operationLot
   */
  function createOperationLotHash(operationLot) {
    if (!operationLot) return null

    const fieldsToHash = [
      'name', 'prixParM2', 'prixVenteTTC', 'surface', 'etage', 'typeLot',
      'lotCoPro', 'comment', 'percentageTreso', 'debutConstruction',
      'finConstruction', 'acteVente', 'sspVente', 'realDate', 'realDateSSP',
      'pretAcheteur', 'depotPermis', 'accordPermis', 'isLoue', 'dateFinBail',
      'loyersPercus', 'tauxTVA', 'nomLocataire', 'dateButoirResiliation',
      'isLotVir', 'schedule'
    ]

    const values = fieldsToHash
      .map(field => {
        const fieldData = operationLot[field]
        if (!fieldData) return 'null'

        let value = fieldData.value
        if (value === null || value === undefined || value === '') {
          return 'null'
        }
        if (typeof value === 'object') {
          return JSON.stringify(value)
        }
        return String(value)
      })
      .join('|')

    let hash = 0
    for (let i = 0; i < values.length; i++) {
      const char = values.charCodeAt(i)
      hash = ((hash << 5) - hash) + char
      hash = hash & hash
    }
    return hash.toString()
  }

  /**
   * Sauvegarder le hash initial d'un lot
   */
  function saveInitialHash(operationLot) {
    if (!operationLot) return

    const lotKey = getLotKey(operationLot)
    const hash = createOperationLotHash(operationLot)

    initialHashes.set(lotKey, hash)
  }

  /**
   * Obtenir une clé unique pour un lot
   */
  function getLotKey(operationLot) {
    return operationLot.id || `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }

  /**
   * Vérifier si un lot a changé depuis son état initial
   */
  function hasLotChanged(operationLot) {
    if (!operationLot) return false

    const lotKey = getLotKey(operationLot)
    const initialHash = initialHashes.get(lotKey)

    if (!initialHash) {
      return true
    }

    const currentHash = createOperationLotHash(operationLot)
    return currentHash !== initialHash
  }

  /**
   * Marquer un lot comme dirty s'il a vraiment changé
   */
  function checkAndMarkDirty(operationLot) {
    if (!operationLot) return false

    const hasChanged = hasLotChanged(operationLot)

    if (hasChanged && !operationLot.isDirty) {
      operationLot.isDirty = true
      return true
    }

    if (!hasChanged && operationLot.isDirty) {
      operationLot.isDirty = false
      return true
    }

    return false
  }

  /**
   * Mettre à jour le hash initial après sauvegarde réussie
   */
  function updateInitialHash(operationLot) {
    if (!operationLot) return

    const lotKey = getLotKey(operationLot)
    const newHash = createOperationLotHash(operationLot)

    initialHashes.set(lotKey, newHash)
    operationLot.isDirty = false
  }

  /**
   * Nettoyer le hash d'un lot supprimé
   */
  function cleanupLotHash(operationLot) {
    if (!operationLot) return

    const lotKey = getLotKey(operationLot)
    initialHashes.delete(lotKey)
  }

  /**
   * Initialiser le tracking pour une liste de lots
   */
  function initializeLotsTracking(operationLots) {
    if (!Array.isArray(operationLots)) return

    operationLots.forEach(lot => {
      saveInitialHash(lot)
      lot.isDirty = false
    })
  }

  /**
   * Obtenir tous les lots qui ont changé
   */
  function getDirtyLots(operationLots) {
    if (!Array.isArray(operationLots)) return []

    return operationLots.filter(lot => hasLotChanged(lot))
  }


  return {
    // Fonctions principales
    saveInitialHash,
    hasLotChanged,
    checkAndMarkDirty,
    updateInitialHash,
    cleanupLotHash,

    // Fonctions utilitaires
    initializeLotsTracking,
    getDirtyLots,
    createOperationLotHash,
    getLotKey,

  }
}



// WEBPACK FOOTER //
// ./src/composable/useDirtyTrackingLot.js